import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './DecreaseInOI.css';
import { format, parseISO } from 'date-fns';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import FandOFut from "../FandOFut";
import { Vortex } from 'react-loader-spinner'

function DecreaseInOI() {
    const [data, setData] = useState([]);
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState('all');
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        if (groupValue === "all") {
            const getUrl = BaseURL + "HighLowOpenIntrest";
            // alert(`${getUrl}/MR/-/fut/-/-/-/DOI/-/-`)
            fetch(`${getUrl}/MR/-/fut/-/-/-/DOI/-/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        } else if (groupValue === "nifty") {
            const getUrl = BaseURL + "HighLowOpenIntrest";
            // alert(`${getUrl}/MR/-/fut/nifty/-/-/DOI/-/-`)
            fetch(`${getUrl}/MR/-/fut/nifty/-/-/DOI/-/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }
        else if (groupValue === "BANKNIFTY") {
            const getUrl = BaseURL + "HighLowOpenIntrest";
            // alert(`${getUrl}/MR/-/fut/BANKNIFTY/-/-/DOI/-/-`)
            fetch(`${getUrl}/MR/-/fut/BANKNIFTY/-/-/DOI/-/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }
        else if (groupValue === "cnxit") {
            const getUrl = BaseURL + "HighLowOpenIntrest";
            // alert(`${getUrl}/MR/-/fut/cnxit/-/-/DOI/-/-`)
            fetch(`${getUrl}/MR/-/fut/cnxit/-/-/DOI/-/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }
        else {
            const getUrl = BaseURL + "HighLowOpenIntrest";
            // alert(`${getUrl}/MR/-/futstk/-/-/-/DOI/-/-`)
            fetch(`${getUrl}/MR/-/futstk/-/-/-/DOI/-/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/futures-and-options">F & O</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Decrease in OI in % (Futures)</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='Decroi-loser-sc'>
                            <div className='Decroi-header'>
                                <h2><span>Decrease In OI</span></h2>
                            </div>
                            <FandOFut optionValue="Decrease in OI in % (Futures)" optionDrop="Futures" />

                            <div className='Decroi-right'>
                                <div className='Decroi-inner-select'>
                                    <select onChange={(event) => { setGroupValue(event.target.value); }}>
                                        <option value="all" selected>All Futures</option>
                                        <option value="nifty">nifty Futures</option>
                                        <option value="BANKNIFTY">BANKNIFTY Futures</option>
                                        <option value="cnxit">cnxit Futures</option>
                                        <option value="stock">stock Futures</option>
                                    </select>
                                </div>

                            </div>

                            <div className='Decroi-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                        <th className='text-left'>Instrument Type</th>
                                            <th className='text-left'>Underlying</th>
                                            <th className='text-right'>Expiry Date</th>
                                            <th className='text-right'>Last Price(&#8377;)</th>
                                            <th className='text-right'>Change (%)</th>
                                            <th className='text-right'>OI</th>
                                            <th className='text-right'>OI Change(%)</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ InstName, Symbol, ExpDate, LTP, FaOchange, OpenInterest, chgOpenInt }) => (
                                                <tr>
                                                    <td className="text-left">{InstName}</td>
                                                    <td className="text-left">{Symbol}</td>
                                                    <td className="text-right">{(ExpDate != null) ? (format(parseISO(ExpDate), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className='text-right'>{LTP.toFixed(2)}</td>
                                                    <td><div className={FaOchange.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {FaOchange != null ? FaOchange.toFixed(2) : 0} </div></td>
                                                    <td className='text-right'>{OpenInterest.toFixed(2)}</td>
                                                    <td><div className={chgOpenInt.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {chgOpenInt != null ? chgOpenInt.toFixed(2) : 0} </div></td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default DecreaseInOI;
